export const useHasIntegratedUx = (
  isIntegratedUser: boolean,
  isApprover: boolean
) => isIntegratedUser && !isApprover;
